import React from "react";
import { useTranslation } from "react-i18next";
import { SKILL_CATEGORIES } from "./skillsData";

const FILTER_KEYS = Object.keys(SKILL_CATEGORIES);

const getButtonClass = (key, activeFilter) => {
    if (activeFilter === key) return "bg-blue-600 text-white shadow-sm";
    if (key === "new") return "bg-green-100 text-green-700 hover:bg-green-200 animate-pulse-subtle ring-1 ring-green-300";
    return "bg-gray-100 text-gray-600 hover:bg-gray-200";
};

const SkillFilters = ({ activeFilter, onFilterChange, searchQuery, onSearchChange }) => {
    const { t } = useTranslation();

    return (
        <div className="space-y-4">
            <style>{`
                @keyframes pulse-subtle {
                    0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4); }
                    50% { box-shadow: 0 0 0 6px rgba(34, 197, 94, 0); }
                }
                .animate-pulse-subtle { animation: pulse-subtle 2s ease-in-out infinite; }
            `}</style>
            <input
                type="text"
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder={t("skillsPage.searchPlaceholder")}
                className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
            />
            <div className="flex flex-wrap gap-2">
                {FILTER_KEYS.map((key) => (
                    <button
                        key={key}
                        onClick={() => onFilterChange(key)}
                        className={`px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${getButtonClass(key, activeFilter)}`}
                    >
                        {t(SKILL_CATEGORIES[key])}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SkillFilters;
